/**
 * Tiles of the start page (docs/architecture/dashboard.md). Modules declare them in the manifest
 * and deliver the component in their web module; the kernel shows the tiles a person may see.
 */
export const TILE_SIZES = ['small', 'medium', 'large'] as const;
export type TileSize = (typeof TILE_SIZES)[number];

export interface DashboardTileDeclaration {
  /** `<module id>.<name>`, e.g. `fleet.inspections-due`. Stable: personal layouts store it. */
  key: string;
  /** i18n key of the tile heading. */
  title: string;
  /** i18n key of a one-line explanation, shown when the person arranges the start page. */
  description?: string;
  /** Required permission. The API behind the tile checks again; this only hides the tile. */
  permission: string;
  /**
   * Width in the grid: `small` one column, `medium` two, `large` the whole row. On the phone
   * every tile takes the whole width. Default `small`.
   */
  size?: TileSize;
  /** Page behind the tile, starting with the module path; the heading links there. */
  path?: string;
}

/** Personal setting with order and hidden tiles of the start page. */
export const DASHBOARD_SETTING = 'core.dashboard';

/**
 * Company setting with the order of the modules in the sidebar and on the start page. The company
 * administration sets it under Verwaltung › Module; `hidden` stays empty, switching a module off
 * is the way to hide it (ADR-0042).
 */
export const MODULE_ORDER_SETTING = 'company.moduleOrder';
